webpackJsonp([248329962088204],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(15);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(601);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// vendor utils
	// vendor
	var Book = function Book(_ref) {
	  var book = _ref.book;
	
	  var videoId = '';
	  var videoSrc = '';
	  var regexp = /([\d])\w+/;
	
	  if (book.video) {
	    var _book$video$match = book.video.match(regexp);
	
	    videoId = _book$video$match[0];
	
	    videoSrc = 'https://player.vimeo.com/video/' + videoId;
	  }
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'book' },
	    _react2.default.createElement(
	      'div',
	      { className: 'book__cover-container' },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: 'book__cover',
	        sizes: book.cover.sizes,
	        alt: book.cover.title
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            href: book.buyingLink,
	            target: '_blank',
	            className: 'book__link',
	            rel: 'noopener noreferrer'
	          },
	          'Acheter'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'book__content-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'book__title-container' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'book__title' },
	          _react2.default.createElement(
	            'span',
	            { className: 'book__title-text' },
	            book.title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'book__body' },
	        _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: book.body.childMarkdownRemark.html
	          }
	        }),
	        videoId.length > 0 && _react2.default.createElement('iframe', {
	          title: 'Vid\xE9o de pr\xE9sentation du livre \xABLes saveurs gastronomiques de la bi\xE8re\xBB.',
	          src: videoSrc,
	          frameBorder: '0',
	          allowFullScreen: true
	        })
	      )
	    )
	  );
	};
	
	// style
	
	
	// vendor components
	
	
	Book.propTypes = {
	  book: _propTypes2.default.shape({
	    cover: _propTypes2.default.shape({
	      sizes: _propTypes2.default.object,
	      title: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.string,
	    body: _propTypes2.default.shape({
	      childMarkdownRemark: _propTypes2.default.shape({ html: _propTypes2.default.string })
	    }),
	    video: _propTypes2.default.string
	  }).isRequired
	};
	
	exports.default = Book;
	module.exports = exports['default'];

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(602);
	
	var _Book = __webpack_require__(134);
	
	var _Book2 = _interopRequireDefault(_Book);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookList = function BookList(_ref) {
	  var books = _ref.books;
	  return _react2.default.createElement(
	    'ul',
	    { className: 'book-list' },
	    books.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(_Book2.default, { book: node, key: node.id });
	    })
	  );
	};
	
	BookList.propTypes = {
	  books: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	};
	
	exports.default = BookList;
	module.exports = exports['default'];

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageTitle = __webpack_require__(16);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _BookList = __webpack_require__(135);
	
	var _BookList2 = _interopRequireDefault(_BookList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// components
	
	
	// vendor components
	var PageLivre = function PageLivre(_ref) {
	  var data = _ref.data;
	  var books = data.books,
	      _data$site$siteMetada = data.site.siteMetadata,
	      siteUrl = _data$site$siteMetada.siteUrl,
	      siteTitle = _data$site$siteMetada.title;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Livres | ' + siteTitle
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'Pr\xE9sentation des nombreux ouvrages publi\xE9s par le duo Les Coureurs des Boires, r\xE9cipiendaires de nombreux prix nationaux et internationaux'
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', value: 'summary' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Livres | Les coureurs des boires' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: siteUrl + '/livres' }),
	      _react2.default.createElement('meta', {
	        property: 'og:description',
	        content: 'Pr\xE9sentation des nombreux ouvrages publi\xE9s par le duo Les Coureurs des Boires, r\xE9cipiendaires de nombreux prix nationaux et internationaux'
	      }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'Les coureurs des boires' }),
	      _react2.default.createElement('link', { rel: 'canonical', href: siteUrl + '/livres' })
	    ),
	    _react2.default.createElement(_PageTitle2.default, { title: 'livres' }),
	    _react2.default.createElement(_BookList2.default, { books: books.edges })
	  );
	};
	
	// utils
	// vendor
	var query = exports.query = '** extracted graphql fragment **';
	
	PageLivre.propTypes = {
	  data: _propTypes2.default.shape({
	    books: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  }).isRequired
	};
	
	exports.default = PageLivre;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-livres-index-jsx-60763e9689aea16eaf4b.js